var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.getUser.user_business.business_logo && !_vm.imgError)?_c('img',{staticClass:"image",attrs:{"src":_vm.getUser.user_business.business_logo,"id":"image-business","alt":"Empresa","width":_vm.width},on:{"error":_vm.onImageError}}):_c('div',{staticClass:"initials-avatar"},[_vm._v(" "+_vm._s(_vm.initials)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }